<div class="encabezado">
  <div>
    <div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="titulo1">{{ getStepTitle() }}</h5>
          <!-- Breadcrumbs -->
          <nav
            aria-label="breadcrumb"
            *ngIf="breadcrumbs.length > 0"
            class="breadcrumb-nav"
          >
            <span
              class="breadcrumb-item"
              *ngFor="let breadcrumb of breadcrumbs; let last = last"
            >
              <a
                *ngIf="!last"
                href="javascript:void(0)"
                (click)="goToStep(breadcrumb.step)"
              >
                {{ breadcrumb.label }}
              </a>
              <span *ngIf="last" class="breadcrumb-current">{{
                breadcrumb.label
              }}</span>
            </span>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div class="tabla" *ngIf="currentStep === 4" [hidden]="campaignTable">
    <div
      class="campaign-units-card mb-4"
      *ngIf="dataSource.data && dataSource.data.length > 0"
    >
      <div class="card-content">
        <div class="card-left">
          <div class="card-icon">
            <i class="icon-layers"></i>
          </div>
          <div class="card-info">
            <div class="vehicle-info mb-1">
              <span
                *ngIf="selectedStock?.stage"
                class="badge text-badge-list"
                [ngClass]="selectedStock.stage | badgeColor:'':''"
              >
                {{ "badge-status_select-stage." + selectedStock.stage | translate }}
              </span>
            </div>
            <div class="vehicle-info-column">
              <div class="vehicle-line" *ngIf="campaignUnitsInfo.vehicle_brand || campaignUnitsInfo.vehicle_models || campaignUnitsInfo.vehicle">
                <span class="vehicle-brand-text">{{ campaignUnitsInfo.vehicle_brand }}</span>
                <span class="vehicle-model-text">{{ campaignUnitsInfo.vehicle_models || campaignUnitsInfo.vehicle }}</span>
              </div>
              <div class="vehicle-line" *ngIf="campaignUnitsInfo.name || campaignUnitsInfo.vehicle_model_year">
                <span class="vehicle-version-text">{{ campaignUnitsInfo.name }}</span>
                <span class="vehicle-year-text" *ngIf="campaignUnitsInfo.vehicle_model_year">({{ campaignUnitsInfo.vehicle_model_year }})</span>
              </div>
              <div class="vehicle-line" *ngIf="campaignUnitsInfo.vehicle_status">
                 <span class="badge text-badge-list" *ngIf="campaignUnitsInfo.type" [ngClass]="campaignUnitsInfo.type | badgeVehicle">
                  {{ "badge-status_select-stage." + campaignUnitsInfo.type | translate }}
                </span>
                <span class="badge text-badge-list" [ngClass]="campaignUnitsInfo.vehicle_status | badgeVehicle">
                  {{ "badge-status_select-stage." + campaignUnitsInfo.vehicle_status | translate }}
                </span>
                <span class="badge text-badge-list" [ngClass]="getBadgeColorRegistered(campaignUnitsInfo.campaign_stock_vehicle_registered)">
                  {{ "badge-status_select-stage." + (campaignUnitsInfo.campaign_stock_vehicle_registered == '1' ? 'registered' : 'not_registered') | translate }}
                </span>
              </div>
              <div class="vehicle-line" *ngIf="campaignUnitsInfo.colour">
                <i class="icon-brush2"></i>
                <span class="vehicle-color-text">{{ campaignUnitsInfo.colour }}</span>
              </div>
              <div class="vehicle-line vehicle-specs-line" *ngIf="campaignUnitsInfo.fuel || campaignUnitsInfo.power">
                <span *ngIf="campaignUnitsInfo.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + campaignUnitsInfo.fuel | translate }}</span>
                <span *ngIf="campaignUnitsInfo.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + campaignUnitsInfo.transmission | translate }}</span>
                <span *ngIf="campaignUnitsInfo.drivetrain" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.drivetrain.' + campaignUnitsInfo.drivetrain | translate }}</span>
                <span *ngIf="campaignUnitsInfo.power" class="vehicle-spec-tag">{{ campaignUnitsInfo.power }} CV</span>
                <span *ngIf="campaignUnitsInfo.doors" class="vehicle-spec-tag">{{ campaignUnitsInfo.doors }}p</span>
                <span *ngIf="campaignUnitsInfo.seats" class="vehicle-spec-tag">{{ campaignUnitsInfo.seats }}pl</span>
                <span *ngIf="campaignUnitsInfo.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + campaignUnitsInfo.emissions_label | translate }}</span>
              </div>
              <div class="vehicle-line" *ngIf="campaignUnitsInfo.campaign_stock_warning_label">
                <span class="badge text-badge-list badge-warning-stock">
                  {{ "inputs.warning_label_options." + campaignUnitsInfo.campaign_stock_warning_label | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-right units-breakdown-vertical">
          <div class="unit-row">
            <span class="unit-number">{{ campaignUnitsInfo.breakdown?.total_units ?? (campaignUnitsInfo.units || 0) }}</span>
            <span class="unit-label">{{ "inputs.totals" | translate }}</span>
          </div>
          <div class="unit-row">
            <span class="unit-number">- {{ campaignUnitsInfo.breakdown?.signed_contracts ?? ((campaignUnitsInfo.units || 0) - (campaignUnitsInfo.available_units || 0)) }}</span>
            <span class="unit-label">{{ "inputs.signed_contracts" | translate }}</span>
          </div>
          <div class="unit-row">
            <span class="unit-number">- {{ campaignUnitsInfo.breakdown?.estimated_in_risk ?? ((campaignUnitsInfo.available_units || 0) - (campaignUnitsInfo.virtual_available_units || 0)) }}</span>
            <span class="unit-label">{{ "inputs.estimated_in_risk" | translate }}</span>
          </div>
          <div class="unit-row unit-row-divider"></div>
          <div class="unit-row unit-row-result">
            <span class="unit-number">{{ campaignUnitsInfo.virtual_available_units || 0 }}</span>
            <span class="unit-label">{{ "inputs.availables" | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="btn-izq gap-2">
      <button
        *ngIf="currentStep === 1"
        class="btn btn-primary ms-2"
        type="button"
        (click)="goToAllCampaignsExpanded()"
      >
        {{ "campaigns.all_campaigns" | translate }} <i class="icon-list"></i>
      </button>

      <button
        *ngIf="shouldShowAddButton()"
        class="btn btn-hover"
        type="button"
        (click)="onAddButtonClick()"
      >
        {{ getAddButtonLabel() }} <i class="icon-plus"></i>
      </button>
     
    </div>
  </div>
  <div class="">
    <!-- Filtros - Visibles en step 3, ocultos en otros pasos -->
    <div class="" [style.display]="(isViewingAllStocks && currentStep === 3) || (isViewingExpanded && currentStep === 5) ? 'block' : 'none'">
      <div class="row">
        <div class="col-8">
          <app-shared-filter
            (filterChanged)="filterChanged($event)"
            [type]="'campaigns'"
            [stage_type]="'all'"
          ></app-shared-filter>
        </div>
      </div>
    </div>

    <!-- Paso 1: Selección de Marcas -->
    <div class="brands-selection" *ngIf="currentStep === 1">
      <!-- Vehículos nuevos -->
      <div class="vehicles-section mt-4" *ngIf="brandsList.length > 0">
        <h6 class="vehicles-subtitle">{{ "campaigns.new_vehicles" | translate }}</h6>
        <div class="row mt-3">
          <div class="col-4-per-row mb-3" *ngFor="let brand of brandsList">
            <div class="brand-card" (click)="selectBrand(brand, 'new')">
              <div class="brand-card-horizontal">
                <div class="brand-card-left">
                  <div class="brand-logo" [innerHTML]="sanitizeSvg(brand.logo)"></div>
                  <h5 class="brand-name">{{ brand.name }}</h5>
                </div>
                <div class="brand-card-right">
                  <!-- Desktop: layout original -->
                  <div class="brand-units-desktop">
                    <div class="d-flex flex-column">
                      <div class="column-list d-flex align-items-center">
                        <span class="badge bg-info">{{ brand.virtual_available_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit">{{ "inputs.availables" | translate }}</span>
                        <span>{{ brand.total_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit-centered">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- Mobile: layout compacto -->
                  <div class="brand-units-mobile">
                    <div class="brand-units-row">
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ brand.virtual_available_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.availables" | translate }}</span>
                      </div>
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ brand.total_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vehículos seminuevos -->
      <div class="vehicles-section mt-5" *ngIf="brandsListUsed.length > 0">
        <h6 class="vehicles-subtitle">{{ "campaigns.used_vehicles" | translate }}</h6>
        <div class="row mt-3">
          <div class="col-4-per-row mb-3" *ngFor="let brand of brandsListUsed">
            <div class="brand-card" (click)="selectBrand(brand, 'used')">
              <div class="brand-card-horizontal">
                <div class="brand-card-left">
                  <div class="brand-logo" [innerHTML]="sanitizeSvg(brand.logo)"></div>
                  <h5 class="brand-name">{{ brand.name }}</h5>
                </div>
                <div class="brand-card-right">
                  <div class="brand-units-desktop">
                    <div class="d-flex flex-column">
                      <div class="column-list d-flex align-items-center">
                        <span class="badge bg-info">{{ brand.virtual_available_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit">{{ "inputs.availables" | translate }}</span>
                        <span>{{ brand.total_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit-centered">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="brand-units-mobile">
                    <div class="brand-units-row">
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ brand.virtual_available_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.availables" | translate }}</span>
                      </div>
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ brand.total_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paso 2: Selección de Modelos -->
    <div class="models-selection" *ngIf="currentStep === 2">
      <!-- Modelos registrados -->
      <div
        class="vehicles-section mt-4"
        *ngIf="modelsListRegistered.length > 0"
      >
        <h6 class="vehicles-subtitle">{{ "campaigns.registered_vehicles" | translate }}</h6>
        <div class="row mt-3">
          <div
            class="col-4-per-row mb-3"
            *ngFor="let model of modelsListRegistered"
          >
            <div class="brand-card" (click)="selectModel(model)">
              <div class="brand-card-horizontal">
                <div class="brand-card-left">
                  <div class="model-icon">
                    <i class="icon-car"></i>
                  </div>
                  <h5 class="brand-name">{{ model.name }}</h5>
                </div>
                <div class="brand-card-right">
                  <div class="brand-units-desktop">
                    <div class="d-flex flex-column">
                      <div class="column-list d-flex align-items-center">
                        <span class="badge bg-info">{{ model.virtual_available_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit">{{ "inputs.availables" | translate }}</span>
                        <span>{{ model.total_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit-centered">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="brand-units-mobile">
                    <div class="brand-units-row">
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ model.virtual_available_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.availables" | translate }}</span>
                      </div>
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ model.total_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modelos no registrados -->
      <div
        class="vehicles-section mt-5"
        *ngIf="modelsListNotRegistered.length > 0"
      >
        <h6 class="vehicles-subtitle">{{ "campaigns.not_registered_vehicles" | translate }}</h6>
        <div class="row mt-3">
          <div
            class="col-4-per-row mb-3"
            *ngFor="let model of modelsListNotRegistered"
          >
            <div class="brand-card" (click)="selectModel(model)">
              <div class="brand-card-horizontal">
                <div class="brand-card-left">
                  <div class="model-icon">
                    <i class="icon-car"></i>
                  </div>
                  <h5 class="brand-name">{{ model.name }}</h5>
                </div>
                <div class="brand-card-right">
                  <div class="brand-units-desktop">
                    <div class="d-flex flex-column">
                      <div class="column-list d-flex align-items-center">
                        <span class="badge bg-info">{{ model.virtual_available_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit">{{ "inputs.availables" | translate }}</span>
                        <span>{{ model.total_units || 0 }}</span>
                        <span class="text-secondary text-sm label-unit-centered">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="brand-units-mobile">
                    <div class="brand-units-row">
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ model.virtual_available_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.availables" | translate }}</span>
                      </div>
                      <div class="brand-unit">
                        <span class="brand-unit-number">{{ model.total_units || 0 }}</span>
                        <span class="brand-unit-label">{{ "inputs.totals" | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paso 3: Tabla de Campañas -->
    <div class="tabla" *ngIf="currentStep === 3">
      <div class="d-flex align-items-center justify-content-end">
        <mat-paginator
          [length]="paginator?.length || 25"
          [pageSize]="paginator?.pageSize || 25"
          [pageSizeOptions]="[5, 10, 25, 100]"
          [hidePageSize]="true"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>

      <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
      <table
        mat-table
        class="full-width-table"
        matSort
        aria-label="Stocks"
        multiTemplateDataRows
        [dataSource]="dataSourceStocks"
      >
        <!-- ring Column -->
        <ng-container matColumnDef="ring">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla"></th>
          <td mat-cell *matCellDef="let row">
            <i
              *ngIf="row.require_action_note"
              Class="icon-pencil text-success icon-alarm-ringing"
            ></i>
          </td>
        </ng-container>

        <!-- reference Column -->
        <ng-container matColumnDef="reference">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('reference')"
          >
            {{ "inputs.reference" | translate }}
            <i *ngIf="sortColumn == 'reference'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
             <div class="column-list">
              <span>{{ row?.campaign_stock_reference }}</span>
              <span
                class="badge text-badge-list"
                [ngClass]="row.stage | badgeColor:row.require_action:row.priority"
              >{{ "badge-status_select-stage." + row?.stage | translate }}</span>
              <span
                *ngIf="row?.campaign_stock_warning_label"
                class="badge text-badge-list mt-1 badge-warning-stock"
              >{{ "inputs.warning_label_options." + row.campaign_stock_warning_label | translate }}</span>
            </div>
          </td>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('name')"
          >
            {{ "inputs.name" | translate }}
            <i *ngIf="sortColumn == 'name'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">{{ row?.name }}</td>
        </ng-container>

        <!-- supplier Column -->
        <ng-container matColumnDef="supplier">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('supplier_name')"
          >
            {{ "inputs.supplier" | translate }}
            <i *ngIf="sortColumn == 'supplier'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngIf="row?.supplier_name"> {{ row?.supplier_name }}</span>
            </div>
          </td>
        </ng-container>

        <!-- vendor Column -->
        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.vendors" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngFor="let vendor of row?.vendors; let last = last">
                {{ vendor }}<span *ngIf="!last">, </span>
              </span>
            </div>
          </td>
        </ng-container>

        <!-- units Column -->
        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.units" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column">
              <div class="column-list d-flex align-items-center">
                <span class="badge bg-info">
                  {{ row?.virtual_available_units || 0 }}</span
                >
                <span
                  class="text-secondary text-sm label-unit"
                >
                  {{ "inputs.availables" | translate }}
                </span>
                <span>{{ row.units || 0 }}</span>
                <span class="label-unit-centered">
                  {{ "inputs.totals" | translate }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- fee Column -->
        <ng-container matColumnDef="fee">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('fee')"
          >
            {{ "inputs.fee" | translate }}
            <i *ngIf="sortColumn == 'fee'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column col-w-90">
              <div class="column-list">
                <span *ngIf="row?.matrix_total"
                  >{{ getMinValue(row?.matrix_total) }} €</span
                >
                <span *ngIf="row?.initial_payment">
                  <i class="icon-cash-euro"></i>
                  {{ "inputs.initial_payment" | translate }}
                  {{ row?.initial_payment }} €
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- vehicle Column -->
        <ng-container matColumnDef="vehicle">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('vehicle')"
          >
            {{ "inputs.vehicle" | translate }}
            <i *ngIf="sortColumn == 'vehicle'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngIf="row?.vehicle_brand">
                {{ row?.vehicle_brand }} {{ row?.vehicle_model }} ({{
                  row?.vehicle_model_year
                }})
              </span>
              <span *ngIf="row?.vehicle">{{ row?.vehicle }}</span>
              <span
                *ngIf="row?.type"
                class="badge text-badge-list"
                [ngClass]="row.type | badgeVehicle"
              >
                {{
                  "badge-status_select-stage." + row?.type | translate
                }}
              </span>
              <span
                *ngIf="row?.vehicle_status"
                class="badge text-badge-list"
                [ngClass]="row.vehicle_status | badgeVehicle"
              >
                {{
                  "badge-status_select-stage." + row?.vehicle_status | translate
                }}
              </span>
               <span
                  class="badge text-badge-list mt-1"
                  [ngClass]="getBadgeColorRegistered(row.vehicle_registered)"
                >
                  {{ "badge-status_select-stage." + (row.vehicle_registered == '1' ? 'registered' : 'not_registered') | translate }}
                </span>
              <span *ngIf="row?.colour" class="secondary-text">
                <i class="icon-brush2"></i> {{ row?.colour }}
              </span>
              <span *ngIf="row?.fuel || row?.power" class="vehicle-specs-inline">
                <span *ngIf="row?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + row.fuel | translate }}</span>
                <span *ngIf="row?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + row.transmission | translate }}</span>
                <span *ngIf="row?.power" class="vehicle-spec-tag">{{ row.power }} CV</span>
                <span *ngIf="row?.doors" class="vehicle-spec-tag">{{ row.doors }}p</span>
                <span *ngIf="row?.seats" class="vehicle-spec-tag">{{ row.seats }}pl</span>
                <span *ngIf="row?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + row.emissions_label | translate }}</span>
              </span>
            </div>
          </td>
        </ng-container>

        <!-- contract Column -->
        <ng-container matColumnDef="contract">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('contract')"
          >
            {{ "inputs.contract" | translate }}
            <i *ngIf="sortColumn == 'contract'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list col-w-160">
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_insurance
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_insurance" | translate }}
                <span *ngIf="row?.include_insurance && row?.insurance_deductible" class="text-muted">({{ "helper.deductible" | translate }}: {{ row.insurance_deductible }}€)</span>
                <i *ngIf="row?.insurance_notes" class="icon-notification include-note-icon" [matTooltip]="row.insurance_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_maintenance
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_maintenance" | translate }}
                <i *ngIf="row?.maintenance_notes" class="icon-notification include-note-icon" [matTooltip]="row.maintenance_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_tires
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_tires" | translate }}
                <i *ngIf="row?.tires_notes" class="icon-notification include-note-icon" [matTooltip]="row.tires_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_replacement_vehicle
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_replacement_vehicle" | translate }}
                <i *ngIf="row?.replacement_vehicle_notes" class="icon-notification include-note-icon" [matTooltip]="row.replacement_vehicle_notes" matTooltipPosition="above"></i>
              </span>
            </div>
          </td>
        </ng-container>

        <!-- period Column -->
        <ng-container matColumnDef="period">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('period')"
          >
            {{ "inputs.period" | translate }}
            <i *ngIf="sortColumn == 'period'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column col-w-160">
              <div class="column-list">
                <span
                  class="text-secondary text-base"
                  *ngIf="row?.start_date"
                >
                  <i class="icon-play-circle"></i>
                  {{ "forms.labels.start" | translate }}
                  {{ row?.start_date | formatDateTimePipe }}
                </span>
                <span
                  class="text-secondary text-base"
                  *ngIf="row?.end_date"
                >
                  <i class="icon-stop-circle"></i>
                  {{ "forms.labels.end" | translate }}
                  {{ row?.end_date | formatDateTimePipe }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- documents Column -->
        <ng-container matColumnDef="documents">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.documents" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex gap-1 flex-wrap">
              <a *ngFor="let doc of row?.documents" [href]="doc.file" target="_blank"
                class="badge bg-light text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
                [title]="doc.name">
                <i class="icon-file-text2"></i> {{ doc.name }}
              </a>
              <a *ngFor="let doc of row?.private_documents" [href]="doc.file" target="_blank"
                class="badge bg-warning text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
                [title]="doc.name">
                <i class="icon-lock"></i> {{ doc.name }}
              </a>
              <span *ngIf="!row?.documents?.length && !row?.private_documents?.length" class="text-muted">—</span>
            </div>
          </td>
        </ng-container>

        <!-- stage Column -->
        <ng-container matColumnDef="stage">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('stage')"
          >
            {{ "inputs.stage" | translate }}
            <i *ngIf="sortColumn == 'stage'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span
                class="badge text-badge-list"
                [ngClass]="row.stage | badgeColor:row.require_action:row.priority"
              >
                {{ "badge-status_select-stage." + row?.stage | translate }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- campaigns Column -->
        <ng-container matColumnDef="campaigns">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.campaigns" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cell-center">
            <div class="column-list align-items-center">
              <span
                class="badge campaign-badge clickable"
              >
                {{ row?.campaign_count || 0 }}
              </span>
              <a
                href="javascript:void(0)"
                class="campaign-link text-base text-decoration-none"
                (click)="goCampaignsFromStock(row)"
              >
                {{ "campaigns.view_campaigns" | translate }}
              </a>
            </div>
          </td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="" *ngIf="accountType == 'supplier'">
              <i
                *ngIf="row.stage == 'draft' || row.stage == 'sql'"
                class="icon-trash text-danger icon-actions"
                (click)="deleteStock(row.reference)"
                [matTooltip]="'tooltip.deleteStock' | translate"
                aria-hidden="true"
              ></i>
              <i
                class="icon-pencil text-success icon-actions"
                (click)="getStock(row.reference)"
                [matTooltip]="'tooltip.editStock' | translate"
                aria-hidden="true"
              ></i>
            </div>
           <!--  <div class="" *ngIf="accountType == 'broker'">
              <i
                class="icon-plus text-success icon-actions"
                (click)="showFormOrder(row)"
                [matTooltip]="'tooltip.addorderforCampaign' | translate"
                aria-hidden="true"
              ></i>
              <i
                class="icon-exit-right text-success icon-actions"
                (click)="goOrders(row.reference)"
                [matTooltip]="'tooltip.vieworders' | translate"
                aria-hidden="true"
              ></i>
            </div> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsStock"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsStock"
          (click)="toggleRow(row)"
          [ngClass]="{
            'tr-selected': expandedRow?.reference === row.reference,
          }"
        ></tr>
      </table>
      </div>
      </div>

      <!-- Mobile: Stock cards -->
      <div class="cards-mobile-wrapper">
        <div *ngFor="let row of dataSourceStocks.data" class="campaign-card"
          (click)="toggleRow(row)">
          <div class="card-header-row">
            <span class="card-ref">{{ row?.campaign_stock_reference }}</span>
            <span class="badge text-badge-list" [ngClass]="row.stage | badgeColor:row.require_action:row.priority">
              {{ "badge-status_select-stage." + row?.stage | translate }}
            </span>
          </div>
          <span *ngIf="row?.campaign_stock_warning_label" class="badge text-badge-list card-warning-badge">
            {{ "inputs.warning_label_options." + row.campaign_stock_warning_label | translate }}
          </span>
          <div class="card-body-content">
            <span *ngIf="row?.vehicle_brand" class="card-detail card-detail-vehicle">
              <i class="icon-car" aria-hidden="true"></i>
              {{ row?.vehicle_brand }} {{ row?.vehicle_model }} ({{ row?.vehicle_model_year }})
            </span>
            <span *ngIf="row?.type" class="badge text-badge-list card-vehicle-badge"
              [ngClass]="row.type | badgeVehicle">
              {{ "badge-status_select-stage." + row?.type | translate }}
            </span>
            <span *ngIf="row?.vehicle_status" class="badge text-badge-list card-vehicle-badge"
              [ngClass]="row.vehicle_status | badgeVehicle">
              {{ "badge-status_select-stage." + row?.vehicle_status | translate }}
            </span>
            <span *ngIf="row?.colour" class="card-detail">
              <i class="icon-brush2" aria-hidden="true"></i> {{ row?.colour }}
            </span>
            <span *ngIf="row?.fuel || row?.power" class="card-detail vehicle-specs-inline">
              <span *ngIf="row?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + row.fuel | translate }}</span>
              <span *ngIf="row?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + row.transmission | translate }}</span>
              <span *ngIf="row?.power" class="vehicle-spec-tag">{{ row.power }} CV</span>
              <span *ngIf="row?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + row.emissions_label | translate }}</span>
            </span>
            <span class="card-detail">
              <i class="icon-layers" aria-hidden="true"></i>
              {{ row?.virtual_available_units || 0 }} {{ "inputs.availables" | translate }} /
              {{ row?.units || 0 }} {{ "inputs.totals" | translate }}
            </span>
            <span *ngIf="row?.vendors?.length" class="card-detail">
              <i class="icon-user" aria-hidden="true"></i>
              <span *ngFor="let vendor of row?.vendors; let last = last">{{ vendor }}<span *ngIf="!last">, </span></span>
            </span>
          </div>
          <div class="card-footer-row" *ngIf="row?.campaign_count">
            <button class="btn-view-campaigns"
              (click)="goCampaignsFromStock(row); $event.stopPropagation()">
              <span class="campaign-badge">{{ row?.campaign_count }}</span>
              {{ "campaigns.view_campaigns" | translate }}
            </button>
          </div>
          <div class="card-footer-row" *ngIf="accountType == 'supplier'">
            <div class="card-actions">
              <i *ngIf="row.stage == 'draft' || row.stage == 'sql'"
                class="icon-trash text-danger icon-actions"
                (click)="deleteStock(row.reference); $event.stopPropagation()" aria-hidden="true"></i>
              <i class="icon-pencil text-success icon-actions"
                (click)="getStock(row.reference); $event.stopPropagation()" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <mat-paginator
        [length]="paginator?.length || 25"
        [pageSize]="paginator?.pageSize || 25"
        [pageSizeOptions]="paginator?.pageSizeOptions || [25, 50, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>

    <!-- Paso 4: Tabla de Campañas (tabla existente) -->
    <div class="tabla" *ngIf="currentStep === 4" [hidden]="campaignTable">
      <!-- Card con información de unidades -->
      <div class="d-flex align-items-center justify-content-end">
        <mat-paginator
          [length]="paginator?.length || 25"
          [pageSize]="paginator?.pageSize || 25"
          [pageSizeOptions]="[5, 10, 25, 100]"
          [hidePageSize]="true"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>

      <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
      <table
        mat-table
        class="full-width-table"
        matSort
        aria-label="Brands"
        multiTemplateDataRows
        [dataSource]="dataSource"
      >
        <!-- (matSortChange)="onSortChange($event)"> -->
        <!-- broker_reference Column -->
        <ng-container matColumnDef="ring">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla"></th>
          <td mat-cell *matCellDef="let row">
            <i
              *ngIf="row.require_action_note"
              Class="icon-pencil text-success icon-alarm-ringing"
            ></i>
          </td>
        </ng-container>

        <!-- campaign_reference Column -->
        <ng-container matColumnDef="campaign_reference">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('campaign_reference')"
          >
            {{ "inputs.reference" | translate }}
            <i
              *ngIf="sortColumn == 'campaign_reference'"
              [ngClass]="getDirection()"
            ></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span>{{ row?.campaign_reference }}</span>
              <span
                *ngIf="row?.warning_label"
                class="badge text-badge-list mt-1 badge-warning-stock"
              >{{ "inputs.warning_label_options." + row.warning_label | translate }}</span>
            </div>
          </td>
        </ng-container>

        <!-- campaign Column -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('name')"
          >
            {{ "inputs.name" | translate }}
            <i *ngIf="sortColumn == 'name'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row?.name }}
          </td>
        </ng-container>

        <!-- supplier/broker Column -->
        <ng-container matColumnDef="supplier">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('supplier_name')"
          >
            <span *ngIf="accountType === 'broker'">{{ "inputs.supplier" | translate }}</span>
            <span *ngIf="accountType === 'supplier'">{{ "inputs.broker" | translate }}</span>
            <i *ngIf="sortColumn == 'supplier'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngIf="accountType === 'broker' && row?.supplier_name">{{ row?.supplier_name }}</span>
              <span *ngIf="accountType === 'supplier' && row?.brokers">{{ row?.brokers }}</span>
            </div>
          </td>
        </ng-container>

        <!-- vendor Column -->
        <ng-container matColumnDef="vendor">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('vendor_name')"
          >
            {{ "inputs.vendor" | translate }}
            <i *ngIf="sortColumn == 'vendor'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngIf="row?.vendor_name"> {{ row?.vendor_name }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="total_units">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('total_units')"
          >
            {{ "inputs.total_units" | translate }}
            <i
              *ngIf="sortColumn == 'total_units'"
              [ngClass]="getDirection()"
            ></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column">
              <div class="column-list">
                <span *ngIf="row?.units">
                  {{ row?.units }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.units" | translate }}
          </th>

          <td mat-cell *matCellDef="let row">
            <div class="units-cell">
              <div class="column-list d-flex align-items-center">
                <span class="badge bg-info">
                  {{ row?.virtual_available_units || 0 }}</span
                >
                <span
                  class="text-secondary text-sm label-unit"
                >
                  {{ "inputs.availables" | translate }}</span
                >
                <span>{{ row.units || 0 }}</span>
                <span class="label-unit-centered">
                  {{ "inputs.totals" | translate }}</span
                >
              </div>
              <i class="icon-info units-info-icon"
                [matTooltip]="getUnitsTooltip(row)"
                matTooltipClass="units-tooltip"
                matTooltipPosition="above"
              ></i>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="fee">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('fee')"
          >
            {{ "inputs.fee" | translate }}
            <i *ngIf="sortColumn == 'fee'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column col-w-90">
              <div class="column-list">
                <span *ngIf="row?.matrix_total">
                  {{ getMinValue(row?.matrix_total) }} €
                </span>
                <span *ngIf="row?.initial_payment"
                  ><i class="icon-cash-euro"></i>
                  {{ "inputs.initial_payment" | translate }}
                  {{ row?.initial_payment }} €
                </span>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- vehicle Column -->
        <ng-container matColumnDef="vehicle">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('vehicle')"
          >
            {{ "inputs.vehicle" | translate }}
            <i *ngIf="sortColumn == 'vehicle'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span *ngIf="row?.vehicle_brand">
                {{ row?.vehicle_brand }} {{ row?.vehicle_models }} ({{
                  row?.vehicle_model_year
                }})
              </span>
              <span *ngIf="row?.vehicle">{{ row?.vehicle }} </span>
              <span *ngIf="row?.colour" class="secondary-text">
                <i class="icon-brush2"></i> {{ row?.colour }}</span
              >
            </div>
            <div class="vehicle-badges-inline" *ngIf="row?.type || row?.vehicle_status">
              <span
                *ngIf="row?.type"
                class="badge text-badge-list"
                [ngClass]="row.type | badgeVehicle"
                >{{
                  "badge-status_select-stage." + row?.type | translate
                }}</span
              >
              <span
                *ngIf="row?.vehicle_status"
                class="badge text-badge-list"
                [ngClass]="row.vehicle_status | badgeVehicle"
                >{{
                  "badge-status_select-stage." + row?.vehicle_status | translate
                }}</span
              >
            </div>
            <div class="vehicle-specs-inline" *ngIf="row?.fuel || row?.power">
              <span *ngIf="row?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + row.fuel | translate }}</span>
              <span *ngIf="row?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + row.transmission | translate }}</span>
              <span *ngIf="row?.power" class="vehicle-spec-tag">{{ row.power }} CV</span>
              <span *ngIf="row?.doors" class="vehicle-spec-tag">{{ row.doors }}p</span>
              <span *ngIf="row?.seats" class="vehicle-spec-tag">{{ row.seats }}pl</span>
              <span *ngIf="row?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + row.emissions_label | translate }}</span>
            </div>
          </td>
        </ng-container>

        <!-- contract only supp Column -->
        <ng-container matColumnDef="contract">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('contract')"
          >
            {{ "inputs.contract" | translate }}
            <i *ngIf="sortColumn == 'contract'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list col-w-160">
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_insurance
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_insurance" | translate }}
                <span *ngIf="row?.include_insurance && row?.insurance_deductible" class="text-muted">({{ "helper.deductible" | translate }}: {{ row.insurance_deductible }}€)</span>
                <i *ngIf="row?.insurance_notes" class="icon-notification include-note-icon" [matTooltip]="row.insurance_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_maintenance
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_maintenance" | translate }}
                <i *ngIf="row?.maintenance_notes" class="icon-notification include-note-icon" [matTooltip]="row.maintenance_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_tires
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_tires" | translate }}
                <i *ngIf="row?.tires_notes" class="icon-notification include-note-icon" [matTooltip]="row.tires_notes" matTooltipPosition="above"></i>
              </span>
              <span class="secondary-text">
                <i
                  [ngClass]="
                    row?.include_replacement_vehicle
                      ? 'icon-check text-success'
                      : 'icon-cross2 text-danger'
                  "
                ></i>
                {{ "helper.include_replacement_vehicle" | translate }}
                <i *ngIf="row?.replacement_vehicle_notes" class="icon-notification include-note-icon" [matTooltip]="row.replacement_vehicle_notes" matTooltipPosition="above"></i>
              </span>
            </div>
          </td>
        </ng-container>

        <!-- period Column -->
        <ng-container matColumnDef="period">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('period')"
          >
            {{ "inputs.period" | translate }}
            <i *ngIf="sortColumn == 'period'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column col-w-160">
              <div class="column-list">
                <span
                  class="text-secondary text-base"
                  *ngIf="row?.start_date"
                >
                  <i class="icon-play-circle"></i>
                  {{ "forms.labels.start" | translate }}
                  {{ row?.start_date | formatDateTimePipe }}
                </span>
                <span
                  class="text-secondary text-base"
                  *ngIf="row?.end_date"
                >
                  <i class="icon-stop-circle"></i>
                  {{ "forms.labels.end" | translate }}
                  {{ row?.end_date | formatDateTimePipe }}
                </span>
                <!--   <span *ngIf="row?.period">
                  {{ row?.period | formatDateTimePipe}}
                </span> -->
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="comments">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('comments')"
          >
            {{ "inputs.comments" | translate }}
            <i *ngIf="sortColumn == 'comments'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column">
              <div class="column-list">
                <span *ngIf="row?.comments">
                  {{ row?.comments }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- updated_at Column -->
        <ng-container matColumnDef="updated_at">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('updated_at')"
          >
            {{ "inputs.updated_at" | translate }}
            <i
              *ngIf="sortColumn == 'updated_at'"
              [ngClass]="getDirection()"
            ></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div
              class="d-flex flex-column"
              *ngIf="
                expandedRow ? expandedRow.reference == row.reference : false;
                else notExpanded
              "
            >
              <div class="column-list">
                <span *ngIf="row?.updated_at">
                  {{ row?.updated_at | formatDateTimePipe }}
                </span>
                <span *ngIf="row?.updated_at" class="secondary-text">
                  <i class="icon-user"></i>
                  {{ row?.updated_by }}
                </span>
              </div>
            </div>
            <ng-template #notExpanded>
              <div class="column-list">
                <span *ngIf="row?.updated_at">
                  {{ row?.updated_at | date: "dd/MM/yyyy" }}
                </span>
                <span *ngIf="row?.updated_at" class="secondary-text">
                  <i class="icon-user"></i>
                  {{ row?.updated_by }}
                </span>
              </div>
            </ng-template>
          </td>
        </ng-container>

        <!-- stage_updated_at Column -->
        <ng-container matColumnDef="stage_updated_at">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('stage_updated_at')"
          >
            {{ "inputs.stage_updated_at" | translate }}
            <i
              *ngIf="sortColumn == 'stage_updated_at'"
              [ngClass]="getDirection()"
            ></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div
              class="d-flex flex-column"
              *ngIf="
                expandedRow ? expandedRow.reference == row.reference : false;
                else notExpanded1
              "
            >
              <div class="column-list">
                <span *ngIf="row?.stage_updated_at">
                  {{ row?.stage_updated_at | formatDateTimePipe }}</span
                >
                <span *ngIf="row?.stage_updated_by" class="secondary-text">
                  <i class="icon-user"></i> {{ row?.stage_updated_by }}</span
                >
              </div>
            </div>
            <ng-template #notExpanded1>
              <div class="column-list">
                <span *ngIf="row?.stage_updated_at">
                  {{ row?.stage_updated_at | date: "dd/MM/yyyy" }}</span
                >
                <span *ngIf="row?.stage_updated_by" class="secondary-text">
                  <i class="icon-user"></i> {{ row?.stage_updated_by }}</span
                >
              </div>
            </ng-template>
          </td>
        </ng-container>

        <!-- documents Column -->
        <ng-container matColumnDef="documents">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.documents" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex gap-1 flex-wrap">
              <a *ngFor="let doc of row?.documents" [href]="doc.file" target="_blank"
                class="badge bg-light text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
                [title]="doc.name">
                <i class="icon-file-text2"></i> {{ doc.name }}
              </a>
              <a *ngFor="let doc of row?.private_documents" [href]="doc.file" target="_blank"
                class="badge bg-warning text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
                [title]="doc.name">
                <i class="icon-lock"></i> {{ doc.name }}
              </a>
              <span *ngIf="!row?.documents?.length && !row?.private_documents?.length" class="text-muted">—</span>
            </div>
          </td>
        </ng-container>

        <!-- stage Column -->
        <ng-container matColumnDef="stage">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="cabecera-tabla"
            (click)="onSortChange2('stage')"
          >
            {{ "inputs.stage" | translate }}
            <i *ngIf="sortColumn == 'stage'" [ngClass]="getDirection()"></i>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="column-list">
              <span
                class="badge text-badge-list"
                [ngClass]="row.stage | badgeColor:row.require_action:row.priority"
                >{{
                  "badge-status_select-stage." + row?.stage | translate
                }}</span
              >

              <span
                *ngIf="row.delivery_status"
                class="badge text-badge-list mt-2"
                [ngClass]="row.delivery_status | badgeDelivery"
              >
                {{
                  "badge-status_select-stage." + row?.delivery_status
                    | translate
                }}</span
              >
            </div>
          </td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
            {{ "inputs.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="" *ngIf="accountType == 'supplier'">
              <i
                *ngIf="row.stage == 'draft' || row.stage == 'sql'"
                class="icon-trash text-danger icon-actions"
                (click)="deleteCampaign(row.reference)"
                [matTooltip]="'tooltip.deletecampaign' | translate"
                aria-hidden="true"
              ></i>

              <i
                class="icon-pencil text-success icon-actions"
                (click)="getCampaign(row.reference)"
                [matTooltip]="'tooltip.editcampaign' | translate"
                aria-hidden="true"
              ></i>

              <i
                class="icon-copy text-info icon-actions"
                (click)="duplicateCampaign(row.reference)"
                [matTooltip]="'tooltip.duplicatecampaign' | translate"
                aria-hidden="true"
              ></i>
            </div>
            <div class="" *ngIf="accountType == 'broker'">
              <i
                *ngIf="row?.documents?.length > 0"
                class="icon-files text-info icon-actions"
                (click)="showDocumentsPopup(row)"
                [matTooltip]="'tooltip.viewDocuments' | translate"
                aria-hidden="true"
              ></i>
              <i
                *ngIf="row?.virtual_available_units > 0"
                class="icon-plus text-success icon-actions"
                (click)="showFormOrder(row)"
                [matTooltip]="'tooltip.addorderforCampaign' | translate"
                aria-hidden="true"
              ></i>
              <i
                class="icon-exit-right text-success icon-actions"
                (click)="goOrders(row.reference)"
                [matTooltip]="'tooltip.vieworders' | translate"
                aria-hidden="true"
              ></i>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="toggleRow(row)"
          [ngClass]="{
            'tr-selected': expandedRow?.reference === row.reference,
          }"
        ></tr>
      </table>
      </div>
      </div>

      <!-- Mobile: Campaign cards -->
      <div class="cards-mobile-wrapper">
        <div *ngFor="let row of dataSource.data" class="campaign-card"
          (click)="toggleRow(row)">
          <div class="card-header-row">
            <div class="card-header-left">
              <span class="card-ref">{{ $any(row)?.campaign_reference }}</span>
              <span *ngIf="$any(row)?.name" class="card-name">{{ $any(row)?.name }}</span>
            </div>
            <span class="badge text-badge-list" [ngClass]="$any(row).stage | badgeColor:$any(row).require_action:$any(row).priority">
              {{ "badge-status_select-stage." + $any(row)?.stage | translate }}
            </span>
          </div>
          <span *ngIf="$any(row)?.warning_label" class="badge text-badge-list card-warning-badge">
            {{ "inputs.warning_label_options." + $any(row).warning_label | translate }}
          </span>
          <div class="card-body-content">
            <span *ngIf="$any(row)?.vehicle_brand" class="card-detail card-detail-vehicle">
              <i class="icon-car" aria-hidden="true"></i>
              {{ $any(row)?.vehicle_brand }} {{ $any(row)?.vehicle_models }} ({{ $any(row)?.vehicle_model_year }})
            </span>
            <span *ngIf="$any(row)?.type" class="badge text-badge-list card-vehicle-badge"
              [ngClass]="$any(row).type | badgeVehicle">
              {{ "badge-status_select-stage." + $any(row)?.type | translate }}
            </span>
            <span *ngIf="$any(row)?.vehicle_status" class="badge text-badge-list card-vehicle-badge"
              [ngClass]="$any(row).vehicle_status | badgeVehicle">
              {{ "badge-status_select-stage." + $any(row)?.vehicle_status | translate }}
            </span>
            <span *ngIf="$any(row)?.fuel || $any(row)?.power" class="card-detail vehicle-specs-inline">
              <span *ngIf="$any(row)?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + $any(row).fuel | translate }}</span>
              <span *ngIf="$any(row)?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + $any(row).transmission | translate }}</span>
              <span *ngIf="$any(row)?.power" class="vehicle-spec-tag">{{ $any(row).power }} CV</span>
              <span *ngIf="$any(row)?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + $any(row).emissions_label | translate }}</span>
            </span>
            <span *ngIf="accountType === 'broker' && $any(row)?.supplier_name" class="card-detail">
              <i class="icon-briefcase" aria-hidden="true"></i> {{ $any(row)?.supplier_name }}
            </span>
            <span *ngIf="accountType === 'supplier' && $any(row)?.brokers" class="card-detail">
              <i class="icon-briefcase" aria-hidden="true"></i> {{ $any(row)?.brokers }}
            </span>
            <span *ngIf="$any(row)?.vendor_name" class="card-detail">
              <i class="icon-user" aria-hidden="true"></i> {{ $any(row)?.vendor_name }}
            </span>
            <span *ngIf="$any(row)?.matrix_total" class="card-detail">
              <i class="icon-coin-euro" aria-hidden="true"></i> {{ getMinValue($any(row)?.matrix_total) }} €
              <span *ngIf="$any(row)?.initial_payment"> + {{ $any(row)?.initial_payment }} € {{ "inputs.initial_payment" | translate }}</span>
            </span>
            <span *ngIf="$any(row)?.start_date || $any(row)?.end_date" class="card-detail">
              <i class="icon-calendar" aria-hidden="true"></i>
              <span *ngIf="$any(row)?.start_date">{{ $any(row)?.start_date | formatDateTimePipe }}</span>
              <span *ngIf="$any(row)?.start_date && $any(row)?.end_date"> — </span>
              <span *ngIf="$any(row)?.end_date">{{ $any(row)?.end_date | formatDateTimePipe }}</span>
            </span>
          </div>
          <div class="card-footer-row">
            <div *ngIf="$any(row)?.delivery_status" class="card-delivery-badge">
              <span class="badge text-badge-list" [ngClass]="$any(row).delivery_status | badgeDelivery">
                {{ "badge-status_select-stage." + $any(row)?.delivery_status | translate }}
              </span>
            </div>
            <div class="card-actions">
              <!-- Supplier actions -->
              <ng-container *ngIf="accountType == 'supplier'">
                <i *ngIf="$any(row).stage == 'draft' || $any(row).stage == 'sql'"
                  class="icon-trash text-danger icon-actions"
                  (click)="deleteCampaign($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
                <i class="icon-pencil text-success icon-actions"
                  (click)="getCampaign($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
                <i class="icon-copy text-info icon-actions"
                  (click)="duplicateCampaign($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
              </ng-container>
              <!-- Broker actions -->
              <ng-container *ngIf="accountType == 'broker'">
                <i *ngIf="$any(row)?.documents?.length > 0"
                  class="icon-files text-info icon-actions"
                  (click)="showDocumentsPopup($any(row)); $event.stopPropagation()" aria-hidden="true"></i>
                <i *ngIf="$any(row)?.virtual_available_units > 0"
                  class="icon-plus text-success icon-actions"
                  (click)="showFormOrder(row); $event.stopPropagation()" aria-hidden="true"></i>
                <i class="icon-exit-right text-success icon-actions"
                  (click)="goOrders($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <mat-paginator
        [length]="paginator?.length || 25"
        [pageSize]="paginator?.pageSize || 25"
        [pageSizeOptions]="paginator?.pageSizeOptions || [25, 50, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showFormOrders }"
  >
    <app-form-add-order
      *ngIf="showFormOrders"
      [tab]="tab"
      [campaignData]="campaignData"
      (backButtonClick)="cerrarFormulario()"
      (addOrder)="refrescar()"
      [ladata]="ladata"
    ></app-form-add-order>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showFormStock }"
  >
    <app-form-add-stock
      *ngIf="showFormStock"
      [stockData]="stockData"
      [stockPreData]="stockPreData"
      [tab]="tab"
      (backButtonClick)="cerrarFormulario()"
      (addOrder)="refrescar()"
      [ladata]="ladata"
      [isEditMode]="isEditMode"
    ></app-form-add-stock>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showForm }"
  >
    <app-form-add-campaign
      *ngIf="showForm"
      [campaignData]="campaignData"
      [campaignPreData]="campaignPreData"
      [tab]="tab"
      (backButtonClick)="cerrarFormulario()"
      (addOrder)="refrescar()"
      [ladata]="ladata"
      [isEditMode]="isEditMode"
    ></app-form-add-campaign>
  </div>

  <!-- STEP 5: Expanded - Todas las campañas -->
  <div class="tabla" *ngIf="currentStep === 5 && isViewingExpanded">
    <div class="table-responsive-wrapper">
    <div class="table-scroll-inner">
    <table mat-table class="full-width-table" [dataSource]="dataSource">

      <ng-container matColumnDef="campaign_stock_reference">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" (click)="onExpandedSort('campaign_stock_reference')">
          {{ "inputs.stock" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list">
            <span>{{ row?.campaign_stock_reference }}</span>
            <span *ngIf="row?.campaign_stock_stage" class="badge tag-item" [ngClass]="row.campaign_stock_stage | badgeColor:'false':'0'">
              {{ "badge-status_select-stage." + row.campaign_stock_stage | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" (click)="onExpandedSort('name')">
          {{ "inputs.campaign" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list">
            <span>{{ row?.name }}</span>
            <span *ngIf="row?.stage" class="badge tag-item" [ngClass]="row.stage | badgeColor:row.require_action:row.priority">
              {{ "badge-status_select-stage." + row.stage | translate }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="vehicle">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.vehicle" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list">
            <span *ngIf="row?.vehicle_brand">
              {{ row.vehicle_brand }} {{ row.vehicle_model }} ({{ row.vehicle_model_year }})
            </span>
            <span *ngIf="row?.vehicle">{{ row.vehicle }}</span>
            <span *ngIf="row?.vehicle_status" class="badge text-badge-list" [ngClass]="row.vehicle_status | badgeVehicle">
              {{ "badge-status_select-stage." + row.vehicle_status | translate }}
            </span>
            <span *ngIf="row?.colour" class="secondary-text">
              <i class="icon-brush2"></i> {{ row.colour }}
            </span>
            <span *ngIf="row?.fuel || row?.power" class="vehicle-specs-inline">
              <span *ngIf="row?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + row.fuel | translate }}</span>
              <span *ngIf="row?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + row.transmission | translate }}</span>
              <span *ngIf="row?.power" class="vehicle-spec-tag">{{ row.power }} CV</span>
              <span *ngIf="row?.doors" class="vehicle-spec-tag">{{ row.doors }}p</span>
              <span *ngIf="row?.seats" class="vehicle-spec-tag">{{ row.seats }}pl</span>
              <span *ngIf="row?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + row.emissions_label | translate }}</span>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="vendor">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.vendor" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row?.vendor_name || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="units">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" (click)="onExpandedSort('units')">
          {{ "inputs.units" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="units-cell">
            <div class="column-list d-flex align-items-center">
              <span class="badge bg-info">
                {{ row?.virtual_available_units || 0 }}</span>
              <span class="text-secondary text-sm label-unit">
                {{ "inputs.availables" | translate }}</span>
              <span>{{ row?.units || 0 }}</span>
              <span class="label-unit-centered">
                {{ "inputs.totals" | translate }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="contract">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.contract" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list col-w-160">
            <span class="secondary-text">
              <i [ngClass]="row?.include_insurance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_insurance" | translate }}
              <span *ngIf="row?.include_insurance && row?.insurance_deductible" class="text-muted">({{ "helper.deductible" | translate }}: {{ row.insurance_deductible }}€)</span>
              <i *ngIf="row?.insurance_notes" class="icon-notification include-note-icon" [matTooltip]="row.insurance_notes" matTooltipPosition="above"></i>
            </span>
            <span class="secondary-text">
              <i [ngClass]="row?.include_maintenance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_maintenance" | translate }}
              <i *ngIf="row?.maintenance_notes" class="icon-notification include-note-icon" [matTooltip]="row.maintenance_notes" matTooltipPosition="above"></i>
            </span>
            <span class="secondary-text">
              <i [ngClass]="row?.include_tires ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_tires" | translate }}
              <i *ngIf="row?.tires_notes" class="icon-notification include-note-icon" [matTooltip]="row.tires_notes" matTooltipPosition="above"></i>
            </span>
            <span class="secondary-text">
              <i [ngClass]="row?.include_replacement_vehicle ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_replacement_vehicle" | translate }}
              <i *ngIf="row?.replacement_vehicle_notes" class="icon-notification include-note-icon" [matTooltip]="row.replacement_vehicle_notes" matTooltipPosition="above"></i>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.period" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="d-flex flex-column col-w-160">
            <div class="column-list">
              <span class="text-secondary text-base" *ngIf="row?.start_date">
                <i class="icon-play-circle"></i>
                {{ "forms.labels.start" | translate }}
                {{ row?.start_date | formatDateTimePipe }}
              </span>
              <span class="text-secondary text-base" *ngIf="row?.end_date">
                <i class="icon-stop-circle"></i>
                {{ "forms.labels.end" | translate }}
                {{ row?.end_date | formatDateTimePipe }}
              </span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="documents">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.documents" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="d-flex gap-1 flex-wrap">
            <a *ngFor="let doc of row?.documents" [href]="doc.file" target="_blank"
              class="badge bg-light text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
              [title]="doc.name">
              <i class="icon-file-text2"></i> {{ doc.name }}
            </a>
            <a *ngFor="let doc of row?.private_documents" [href]="doc.file" target="_blank"
              class="badge bg-warning text-dark text-truncate" style="max-width:120px;font-size:0.75rem;text-decoration:none"
              [title]="doc.name">
              <i class="icon-lock"></i> {{ doc.name }}
            </a>
            <span *ngIf="!row?.documents?.length && !row?.private_documents?.length" class="text-muted">—</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="stage">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla" (click)="onExpandedSort('stage')">
          {{ "inputs.stage" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="badge tag-item" [ngClass]="row.stage | badgeColor:row.require_action:row.priority">
            {{ "badge-status_select-stage." + row?.stage | translate }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.actions" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <!-- Supplier actions -->
          <div *ngIf="accountType === 'supplier'">
            <i class="icon-pencil text-success icon-actions"
              (click)="getCampaign(row.reference); $event.stopPropagation()"
              [matTooltip]="'tooltip.editcampaign' | translate"
              aria-hidden="true"></i>
            <i class="icon-copy text-info icon-actions"
              (click)="duplicateCampaign(row.reference); $event.stopPropagation()"
              [matTooltip]="'tooltip.duplicatecampaign' | translate"
              aria-hidden="true"></i>
          </div>
          <!-- Broker actions -->
          <div *ngIf="accountType === 'broker'">
            <i *ngIf="row?.documents?.length > 0"
              class="icon-folder-search text-info icon-actions"
              (click)="showDocumentsPopup(row); $event.stopPropagation()"
              [matTooltip]="'tooltip.viewDocuments' | translate"
              aria-hidden="true"></i>
            <i class="icon-exit-right text-success icon-actions"
              (click)="goOrders(row.reference); $event.stopPropagation()"
              [matTooltip]="'tooltip.vieworders' | translate"
              aria-hidden="true"></i>
            <i *ngIf="row?.virtual_available_units > 0"
              class="icon-plus text-success icon-actions"
              (click)="showFormOrder(row); $event.stopPropagation()"
              [matTooltip]="'tooltip.addorderforCampaign' | translate"
              aria-hidden="true"></i>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['campaign_stock_reference','name','units','vehicle','vendor','contract','period','actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['campaign_stock_reference','name','units','vehicle','vendor','contract','period','actions']"
        class="clickable-row"></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td class="mat-mdc-cell no-data-cell" colspan="9"><!-- expanded -->
          <div class="no-data-row">
            <i class="icon-info"></i>
            {{ 'tables.no_results' | translate }} (0)
          </div>
        </td>
      </tr>
    </table>
    </div>
    </div>

    <!-- Mobile card layout -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="campaign-card">
        <div class="card-header-row">
          <div class="card-header-left">
            <span class="card-ref">{{ $any(row)?.campaign_stock_reference }}</span>
            <span *ngIf="$any(row)?.name" class="card-name">{{ $any(row)?.name }}</span>
          </div>
          <span class="badge text-badge-list" [ngClass]="$any(row).stage | badgeColor:$any(row).require_action:$any(row).priority">
            {{ "badge-status_select-stage." + $any(row)?.stage | translate }}
          </span>
        </div>
        <div *ngIf="$any(row)?.campaign_stock_stage" class="mb-1">
          <span class="badge tag-item" style="font-size:0.7rem" [ngClass]="$any(row).campaign_stock_stage | badgeColor:'false':'0'">
            {{ "badge-status_select-stage." + $any(row).campaign_stock_stage | translate }}
          </span>
        </div>
        <div class="card-body-content">
          <span *ngIf="$any(row)?.vehicle_brand" class="card-detail card-detail-vehicle">
            <i class="icon-car" aria-hidden="true"></i>
            {{ $any(row)?.vehicle_brand }} {{ $any(row)?.vehicle_model }} ({{ $any(row)?.vehicle_model_year }})
          </span>
          <span *ngIf="$any(row)?.vehicle" class="card-detail">{{ $any(row)?.vehicle }}</span>
          <span *ngIf="$any(row)?.vehicle_status" class="badge text-badge-list card-vehicle-badge"
            [ngClass]="$any(row).vehicle_status | badgeVehicle">
            {{ "badge-status_select-stage." + $any(row)?.vehicle_status | translate }}
          </span>
          <span *ngIf="$any(row)?.colour" class="card-detail">
            <i class="icon-brush2" aria-hidden="true"></i> {{ $any(row)?.colour }}
          </span>
          <span *ngIf="$any(row)?.fuel || $any(row)?.power" class="card-detail vehicle-specs-inline">
            <span *ngIf="$any(row)?.fuel" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.fuel.' + $any(row).fuel | translate }}</span>
            <span *ngIf="$any(row)?.transmission" class="vehicle-spec-tag">{{ 'vehicle_taxonomies.transmission.' + $any(row).transmission | translate }}</span>
            <span *ngIf="$any(row)?.power" class="vehicle-spec-tag">{{ $any(row).power }} CV</span>
            <span *ngIf="$any(row)?.emissions_label" class="vehicle-spec-tag badge-emissions">{{ 'vehicle_taxonomies.emissions_label.' + $any(row).emissions_label | translate }}</span>
          </span>
          <span *ngIf="$any(row)?.vendor_name" class="card-detail">
            <i class="icon-user" aria-hidden="true"></i> {{ $any(row)?.vendor_name }}
          </span>
          <span class="card-detail">
            <i class="icon-layers" aria-hidden="true"></i>
            {{ $any(row)?.virtual_available_units || 0 }} {{ "inputs.availables" | translate }} /
            {{ $any(row)?.units || 0 }} {{ "inputs.totals" | translate }}
          </span>
          <span *ngIf="$any(row)?.start_date || $any(row)?.end_date" class="card-detail">
            <i class="icon-calendar" aria-hidden="true"></i>
            <span *ngIf="$any(row)?.start_date">{{ $any(row)?.start_date | formatDateTimePipe }}</span>
            <span *ngIf="$any(row)?.start_date && $any(row)?.end_date"> — </span>
            <span *ngIf="$any(row)?.end_date">{{ $any(row)?.end_date | formatDateTimePipe }}</span>
          </span>
          <div class="d-flex flex-wrap gap-1 mt-1">
            <span class="secondary-text">
              <i [ngClass]="$any(row)?.include_insurance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_insurance" | translate }}
            </span>
            <span class="secondary-text">
              <i [ngClass]="$any(row)?.include_maintenance ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_maintenance" | translate }}
            </span>
            <span class="secondary-text">
              <i [ngClass]="$any(row)?.include_tires ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_tires" | translate }}
            </span>
            <span class="secondary-text">
              <i [ngClass]="$any(row)?.include_replacement_vehicle ? 'icon-check text-success' : 'icon-cross2 text-danger'"></i>
              {{ "helper.include_replacement_vehicle" | translate }}
            </span>
          </div>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <!-- Supplier actions -->
            <ng-container *ngIf="accountType === 'supplier'">
              <i class="icon-pencil text-success icon-actions"
                (click)="getCampaign($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
              <i class="icon-copy text-info icon-actions"
                (click)="duplicateCampaign($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
            </ng-container>
            <!-- Broker actions -->
            <ng-container *ngIf="accountType === 'broker'">
              <i *ngIf="$any(row)?.documents?.length > 0"
                class="icon-folder-search text-info icon-actions"
                (click)="showDocumentsPopup($any(row)); $event.stopPropagation()" aria-hidden="true"></i>
              <i class="icon-exit-right text-success icon-actions"
                (click)="goOrders($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
              <i *ngIf="$any(row)?.virtual_available_units > 0"
                class="icon-plus text-success icon-actions"
                (click)="showFormOrder(row); $event.stopPropagation()" aria-hidden="true"></i>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [pageSizeOptions]="[25, 50, 100]"
      (page)="onExpandedPageChange($event)"
      aria-label="Select page">
    </mat-paginator>
  </div>

  <div
    class="overlay"
    *ngIf="showFormOrders || showForm || showFormStock"
    (click)="cerrarFormulario()"
  ></div>
</div>
